import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpenIcon } from 'lucide-react';
export function TheSystem() {
  const tomos = [{
    num: '1',
    title: 'La Psicología del Escenario',
    desc: 'Tu presencia cambia antes de que empiece la música. Autoridad, lenguaje corporal, energía de sala y el sistema de "anclaje de identidad" para entrar en estado de flujo aunque hayas tenido el peor día de tu vida.'
  }, {
    num: '2',
    title: 'Cueing de Conexión Emocional',
    desc: 'Dejás de decir las palabras correctas para empezar a decir las palabras que mueven. Cueing técnico, emocional e identitario, metáforas de poder, modulación de voz y los rescates verbales que salvan cualquier track.'
  }, {
    num: '3',
    title: 'El Guion Perfecto',
    desc: 'Tu clase tiene estructura narrativa real. Apertura que engancha, arco emocional de 10 tracks, el clímax en Lunges y un cierre que hace que la gente no quiera irse. La clase como historia que se recuerda.'
  }, {
    num: '4',
    title: 'Diseño de Atmósfera',
    desc: 'La experiencia empieza antes de que lleguen y termina después de que se van. Rituales de sala, comunidad, sensorialidad y los pequeños detalles que hacen que tu horario se sienta único e irreemplazable.'
  }, {
    num: '5',
    title: 'Fidelización Post-Clase',
    desc: 'El sistema de 72 horas que convierte un alumno ocasional en un fanático. Seguimiento, conexión post-clase, retención y cómo construir una comunidad que se vuelva tu mejor herramienta de marketing.'
  }, {
    num: '6',
    title: 'Marketing de Sala',
    desc: 'Tu marca personal funciona para vos incluso cuando no estás dando clase. Instagram, posicionamiento, alianzas estratégicas y cómo hacer que la gente elija tu horario antes de abrir la grilla del gimnasio.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-pump-dark" data-id="element-213">
      <div className="max-w-6xl mx-auto" data-id="element-214">
        <FadeIn data-id="element-215">
          <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-216">
            <h2 className="text-4xl sm:text-6xl font-display font-black text-white mb-6 uppercase tracking-tight" data-id="element-217">
              EL <span className="text-pump-gold" data-id="element-218">PROTOCOLO</span>
              <br data-id="element-219" />
              ES ESE SISTEMA.
            </h2>
            <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-220">
              No es una colección de tips de Instagram. No es contenido
              motivacional con fondo de gimnasio. No es un manual teórico que
              vas a leer una vez y guardar en una carpeta.
            </p>
            <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-221">
              Es el sistema completo que transforma la forma en que das clase,
              la forma en que te posicionás y la forma en que la gente te
              recuerda. De la presencia escénica al marketing personal. Del
              cueing a la fidelización.
            </p>
            <p className="text-xl sm:text-2xl font-bold text-white" data-id="element-222">
              Todo conectado. Todo con criterio. Todo listo para usar desde hoy.
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-223">
          <h3 className="text-2xl font-display font-bold text-center text-pump-gold mb-10" data-id="element-224">
            Los 6 tomos que entran al sistema cuando comprás el protocolo:
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-225">
          {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-226">
              <div className="bg-pump-surface border border-pump-muted rounded-2xl p-6 sm:p-8 h-full relative overflow-hidden group hover:border-pump-gold/40 transition-all" data-id="element-227">
                <div className="absolute top-0 right-0 text-[120px] font-black text-pump-dark leading-none -mt-4 -mr-4 pointer-events-none group-hover:text-pump-gold/5 transition-colors" data-id="element-228">
                  {tomo.num}
                </div>
                <div className="relative z-10" data-id="element-229">
                  <div className="flex items-center gap-3 mb-4" data-id="element-230">
                    <div className="bg-pump-gold/10 text-pump-gold p-2 rounded-lg" data-id="element-231">
                      <BookOpenIcon className="w-6 h-6" data-id="element-232" />
                    </div>
                    <span className="text-pump-gold font-bold tracking-wider text-sm uppercase" data-id="element-233">
                      Tomo {tomo.num}
                    </span>
                  </div>
                  <h4 className="text-2xl font-display font-bold text-white mb-4" data-id="element-234">
                    {tomo.title}
                  </h4>
                  <p className="text-gray-400 leading-relaxed" data-id="element-235">{tomo.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}